import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  StateStatus,
} from '../../../redux/utils/common';
import * as RegistrationDetailService from '../../../services/api/registration_detail';
import {
  getCountriesNotInStateMember,
  getSchemeTypes,
  getAllCountries,
  getCountriesMemberStateExcludeCyprus,
  getCountriesExludeCyprus,
} from '../../../services/api/register';
import NavigationConfig from '../../../navigation/config';
import ModalActions from '../../reducers/gl_modal_reducer/actions';
import { ModalIDs } from '../gl_modal_reducer/types';
import * as ApplicantService from '../../../services/api/applicant';

interface FetchRegistrationDetailInput {
  id: number;
}

class FetchRegistrationDetail implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_REGISTRATION_DETAIL,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_REGISTRATION_DETAIL,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_REGISTRATION_DETAIL,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FetchRegistrationDetailInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegistrationDetailService.fethRegistrationDetail(
          payload.id
        );

        let details = response.data;
        let fixed_establish_details = response.data.fixed_establish_details;
        let previous_use_of_special_schemes =
          response.data.previous_use_of_special_schemes;
        let identification_in_other_countries =
          response.data.identification_in_other_countries;

        delete details.fixed_establish_details;
        delete details.previous_use_of_special_schemes;
        delete details.identification_in_other_countries;

        dispatch(
          this.onSuccess({
            data: details,
            fixed_establish_details,
            previous_use_of_special_schemes,
            identification_in_other_countries,
          })
        );
      } catch (error: any) {
        // console.log('FetchSchemeTypes Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

/** Fetch non member state Countries */
class FetchNonMemberStateCountries implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_NON_MEMBER_STATE_COUNTRIES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_NON_MEMBER_STATE_COUNTRIES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_NON_MEMBER_STATE_COUNTRIES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await getCountriesNotInStateMember();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchNonMemberStateCountries Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

/** Fetch IMPORT Countries */
class FetchImportCountries implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_IMPORT_COUNTRIES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_IMPORT_COUNTRIES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_IMPORT_COUNTRIES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await getCountriesNotInStateMember('CY');
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchImportCountries Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

/** Fetch member state Countries */
class FetchMemberStateCountries implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_COUNTRIES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MEMBER_STATE_COUNTRIES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_COUNTRIES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await getCountriesMemberStateExcludeCyprus();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMemberStateCountries Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

/** Fetch All Countries */
class FetchAllCountries implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_ALL_COUNTRIES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_ALL_COUNTRIES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_ALL_COUNTRIES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await getAllCountries();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchAllCountries Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

//Fetch scheme types
class FetchSchemeTypes implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_SCHEME_TYPES,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_SCHEME_TYPES,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_SCHEME_TYPES,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await getSchemeTypes();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Fetch Scheme Types Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IdentificationInOtherEuCountriesInput {
  vat_id_num: string;
  country_id: number;
  id: number;
}
//SetIdentificationInOtherEuCountries types
class SetIdentificationInOtherEuCountries implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_IDENTIFICATION_IN_OTHER_EU_COUNTRIES,
      status: StateStatus.Success,
      data: data,
    };
  }

  action(payload: IdentificationInOtherEuCountriesInput[]): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess(payload));
    };
  }
}

interface PreviousUseOfSpecialSchemeInput {
  id: number;
  country_id: number;
  country: string;
  vat_id_num: string;
  applicant_type_id: number;
}
//PreviousUseOfSpecialScheme types
class SetPreviousUseOfSpecialScheme implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_PREVIOUS_USE_OF_SPECIAL_SCHEME,
      status: StateStatus.Success,
      data: data,
    };
  }

  action(payload: PreviousUseOfSpecialSchemeInput[]): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess(payload));
    };
  }
}

interface FixedEstablishmentInput {
  fixed_establish_id: number;
  address_free: string;
  building_identifier: string;
  cessation_date: Date;
  city: string;
  country_sub_entity: string;
  district_name: string;
  fixed_establish_address_id?: number;
  floor_identifier: string;
  issuing: number;
  name: string;
  other_local_id: string | null;
  pob: string;
  post_code: string;
  start_date: Date;
  street: string;
  suite_identifier: string;
  type_id: number;
  type: string;
}
//PreviousUseOfSpecialScheme types
class SetFixedEstablishment implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_FIX_ESTABLISHMENTS,
      status: StateStatus.Success,
      data: data,
    };
  }

  action(payload: FixedEstablishmentInput[]): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess(payload));
    };
  }
}

interface ISave {
  id: number;
  payload: any;
  history: any;
  isExcluded: boolean;
}

//TEMPORARY_SAVE_REGISTRATION
class TemporarySaveRegistration implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.TEMPORARY_SAVE_REGISTRATION,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.TEMPORARY_SAVE_REGISTRATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.TEMPORARY_SAVE_REGISTRATION,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(data: ISave): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await RegistrationDetailService.saveTemporaryRegistration(
            data.payload,
            data.id,
            data.isExcluded ? 'exclude' : ''
          );
        dispatch(new FetchRegistrationDetail().action({ id: data.id }));
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Temporary Save Registration Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

//FINAL SUBMIT REGISTRATION
class FinalSubmitRegistration implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.FINAL_SUBMIT_REGISTRATION,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.FINAL_SUBMIT_REGISTRATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.FINAL_SUBMIT_REGISTRATION,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(data: ISave): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegistrationDetailService.finalSubmitRegistration(
          data.payload,
          data.id,
          data.isExcluded ? 'exclude' : ''
        );
        data.history.push(
          NavigationConfig.registrationDetailPage(`${data.id}`, 'view').path
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Temporary Save Registration Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IResponseInput {
  id: number;
  comments: string;
  isExcluded: boolean;
  registration_date: Date;
  commencement_date: Date;
}

//APPROVE REGISTRATION
class ApproveRegistration implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.APPROVE_REGISTRATION,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.APPROVE_REGISTRATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.APPROVE_REGISTRATION,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(data: IResponseInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegistrationDetailService.approveRegistration(
          data.comments,
          data.id,
          data.registration_date,
          data.commencement_date,
          data.isExcluded ? 'exclude' : ''
        );
        dispatch(
          ModalActions.closeModalAction({
            modalID: ModalIDs.MODAL_ADMIN_RESPONSE,
          })
        );
        // data.history.push(
        //   NavigationConfig.registrationDetailPage(data.id, 'view').path
        // );
        dispatch(this.onSuccess(response.data));
        dispatch(
          new FetchRegistrationDetail().action({
            id: data.id,
          })
        );
      } catch (error: any) {
        // console.log('Approve Registration Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

//REJECT REGISTRATION
class RejectRegistration implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.REJECT_REGISTRATION,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.REJECT_REGISTRATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.REJECT_REGISTRATION,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(data: IResponseInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegistrationDetailService.rejectRegistration(
          data.comments,
          data.id,
          data.registration_date,
          data.commencement_date,
          data.isExcluded ? 'exclude' : ''
        );
        dispatch(
          ModalActions.closeModalAction({
            modalID: ModalIDs.MODAL_ADMIN_RESPONSE,
          })
        );
        // data.history.push(
        //   NavigationConfig.registrationDetailPage(data.id, 'view').path
        // );
        dispatch(this.onSuccess(response.data));
        dispatch(
          new FetchRegistrationDetail().action({
            id: data.id,
          })
        );
      } catch (error: any) {
        // console.log('Reject Registration Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

//UPDATE REGISTRATION
class UpdateRegistration implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.UPDATE_REGISTRATION,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.UPDATE_REGISTRATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.UPDATE_REGISTRATION,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: any): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegistrationDetailService.updateRegistration(
          payload.id
        );
        dispatch(this.onSuccess(response.data));
        payload.history.push(
          NavigationConfig.registrationDetailPage(
            response.data.REGISTRATION_ID,
            'edit'
          ).path
        );
      } catch (error: any) {
        // console.log('Update Registration Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

//EXCLUDE REGISTRATION
class ExcludeRegistration implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.EXCLUDE_REGISTRATION,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.EXCLUDE_REGISTRATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.EXCLUDE_REGISTRATION,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: any): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegistrationDetailService.excludeRegistration(
          payload.id
        );
        dispatch(this.onSuccess(response.data));
        payload.history.push(
          NavigationConfig.registrationDetailPage(
            response.data.REGISTRATION_ID,
            'edit'
          ).path
        );
      } catch (error: any) {
        // console.log('Exclude Registration Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

/** Fetch id types */
class FetchIdTypes implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_ID_TYPE,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_ID_TYPE,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_ID_TYPE,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegistrationDetailService.getIdTypes();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchCountries Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchCountriesExcludeCyprus implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_COUNTRIES_EXCLUDE_CYPRUS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_COUNTRIES_EXCLUDE_CYPRUS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_COUNTRIES_EXCLUDE_CYPRUS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await getCountriesExludeCyprus();
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('getCountriesExludeCyprus Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

//CANCEL REGISTRATION
class CancelRegistration implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.CANCEL_REGISTRATION,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.CANCEL_REGISTRATION,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.CANCEL_REGISTRATION,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: any): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RegistrationDetailService.cancelRegistration(
          payload.id
        );
        dispatch(this.onSuccess(response.data));
        payload.history.push(NavigationConfig.registrationListPage().path);
        // payload.history.push(
        //   NavigationConfig.registrationDetailPage(
        //     response.data.REGISTRATION_ID,
        //     'edit'
        //   ).path
        // );
      } catch (error: any) {
        // console.log('Exclude Registration Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IApplicantActiveRegistrationsPayload {
  applicant_id: string;
}
class FetchApplicantActiveRegistrations implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_APPLICANT_ACTIVE_REGISTRATIONS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_APPLICANT_ACTIVE_REGISTRATIONS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_APPLICANT_ACTIVE_REGISTRATIONS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action({ applicant_id }: IApplicantActiveRegistrationsPayload): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await ApplicantService.fetchApplicantActiveRegistrations(
          { applicant_id }
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('Applicant active regs Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchRegistrationDetailAction: (payload: FetchRegistrationDetailInput) =>
    new FetchRegistrationDetail().action(payload),
  fetchNonMemberStateCountriesAction: () =>
    new FetchNonMemberStateCountries().action(),
  fetchImportCountriesAction: () => new FetchImportCountries().action(),
  fetchSchemeTypesAction: () => new FetchSchemeTypes().action(),
  setIdentificationInOtherEuCountriesAction: (
    payload: IdentificationInOtherEuCountriesInput[]
  ) => new SetIdentificationInOtherEuCountries().action(payload),
  setPreviousUseOfSpecialScheme: (payload: PreviousUseOfSpecialSchemeInput[]) =>
    new SetPreviousUseOfSpecialScheme().action(payload),
  setFixedEstablishment: (payload: FixedEstablishmentInput[]) =>
    new SetFixedEstablishment().action(payload),
  temporarySaveRegistration: (payload: any) =>
    new TemporarySaveRegistration().action(payload),
  finalSubmitRegistration: (payload: any) =>
    new FinalSubmitRegistration().action(payload),
  approveRegistration: (payload: any) =>
    new ApproveRegistration().action(payload),
  rejectRegistration: (payload: any) =>
    new RejectRegistration().action(payload),
  updateRegistration: (payload: any) =>
    new UpdateRegistration().action(payload),
  excludeRegistration: (payload: any) =>
    new ExcludeRegistration().action(payload),
  cancelRegistration: (payload: any) =>
    new CancelRegistration().action(payload),
  fetchIdTypesAction: () => new FetchIdTypes().action(),
  fetchAllCountriesAction: () => new FetchAllCountries().action(),
  fetchMemberStateCountriesAction: () =>
    new FetchMemberStateCountries().action(),
  fetchCountriesExcludeCyprus: () => new FetchCountriesExcludeCyprus().action(),
  fetchApplicantActiveRegistrations: (
    payload: IApplicantActiveRegistrationsPayload
  ) => new FetchApplicantActiveRegistrations().action(payload),
};
